<template>
  <div class="empty">
    <van-empty
      class="empty-body"
      :image="require('../image/暂无数据@2x.png')"
      :description="text"
    />
  </div>
</template>

<script>
export default {
  props: {
    text: String,
  },
};
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  height: 100%;
  width: 100%;
  .empty-body {
    margin: auto;
    >>> .van-empty__image {
      width: 90px;
      height: 90px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/empty.vue